import { Decimal as PBDecimal } from "gen/proto/decimal/models_pb"
import { Decimal } from "shared-ts/classes/decimal"

import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type DecimalQuantityAccessorFn<T> = TypedAccessor<
  T,
  PBDecimal | Decimal | undefined
>

interface DecimalQuantityColumn<T>
  extends Omit<DataColumn<T>, "type" | "renderCell" | "width"> {
  width?: DataColumn<T>["width"]
}

export type DecimalQuantityColumnHelper<T> = (
  accessorFn: DecimalQuantityAccessorFn<T>,
  col: DecimalQuantityColumn<T>
) => DataColumn<T>

export function decimalQuantity<T>(
  accessorFn: DecimalQuantityAccessorFn<T>,
  col: DecimalQuantityColumn<T>
): DataColumn<T> {
  const { width, ...otherCol } = col
  return data({
    renderCell: (rowData) => {
      const value = accessorFn(rowData)
      if (value === undefined) return null
      return Decimal.fromPB(value).toString()
    },
    width: width ?? TableCellWidth.Small,
    ...otherCol,
  })
}
